import script from "./LingoStudentVocabularyListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentVocabularyListView.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentVocabularyListView.vue?vue&type=style&index=0&id=9a2a29e2&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2a29e2"]])

export default __exports__